<ndt-prompt-detail-view
   [prompt]="prompt$ | async"
   [promptPrivileges]="promptPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (deletePrompt)="onDeletePrompt($event)"
   (cancelFormSave)="onCancelFormSaveIfNewFile()"
   (emitNewFileId)="updateNewFileId($event)"
   (promptUpdatedViaCallToRecord)="onPromptUpdatedViaCallToRecord($event)"
></ndt-prompt-detail-view>
